import { DynamicConfig } from '@statsig/js-client';
import { Injectable } from '@angular/core';
import { StatsigService } from '@services/statsig.service';

enum GROUP_SELECTION_IMPROVEMENTS_CONFIG {
  groupSelectionEnhancementEnabled = 'groupSelectionEnhancementEnabled',
  groupsTabPaginationEnabled = 'groupsTabPaginationEnabled',
  groupsApiCallEnhancementEnabled = 'groupsApiCallEnhancementEnabled',
  groupsStreamEnhancementEnabled = 'groupsStreamEnhancementEnabled',
  bulkEntityCacheEnabled = 'bulkEntityCacheEnabled',
  bulkEntityVehicleCacheEnabled = 'bulkEntityVehicleCacheEnabled',
  setLastUpdatedAtOnLoadRequest = 'setLastUpdatedAtOnLoadRequest',
  LIMIT_RESULT_PER_ENTITY_TO = 'limitResultsPerEntityTo',
}

@Injectable({ providedIn: 'root' })
export class GroupSelectionImprovementsConfigService {
  private config: DynamicConfig;

  constructor(private statsigService: StatsigService) {
    this.config = this.statsigService.evaluateDynamicConfig('fe-group-selection-improvements-config');
  }

  public isGroupSelectionEnhancementEnabled(): boolean {
    return this.config.get(GROUP_SELECTION_IMPROVEMENTS_CONFIG.groupSelectionEnhancementEnabled, false);
  }

  public isGroupsTabPaginationEnabled(): boolean {
    return this.config.get(GROUP_SELECTION_IMPROVEMENTS_CONFIG.groupsTabPaginationEnabled, false);
  }

  public isGroupsAPICallEnhancementEnabled(): boolean {
    return this.config.get(GROUP_SELECTION_IMPROVEMENTS_CONFIG.groupsApiCallEnhancementEnabled, false);
  }

  public isGroupsStreamEnhancementEnabled(): boolean {
    return this.config.get(GROUP_SELECTION_IMPROVEMENTS_CONFIG.groupsStreamEnhancementEnabled, false);
  }

  public isBulkEntityCacheEnabled(): boolean {
    return this.config.get(GROUP_SELECTION_IMPROVEMENTS_CONFIG.bulkEntityCacheEnabled, false);
  }

  public isBulkEntityVehicleCacheEnabled(): boolean {
    return this.config.get(GROUP_SELECTION_IMPROVEMENTS_CONFIG.bulkEntityVehicleCacheEnabled, false);
  }

  public setLastUpdatedAtOnLoadRequest(): boolean {
    return this.config.get(GROUP_SELECTION_IMPROVEMENTS_CONFIG.setLastUpdatedAtOnLoadRequest, false);
  }

  public getMaxSearchResultsPerEntity(): number | null {
    const result = this.config.get(GROUP_SELECTION_IMPROVEMENTS_CONFIG.LIMIT_RESULT_PER_ENTITY_TO, null);
    return typeof result === 'number' ? result : null;
  }
}
